module.exports = __webpack_public_path__ + "static/media/challenge-qr.8c627de5.svg";